import React, { useState, useEffect } from 'react';
import '../css/ActivityViewer.css';

const ActivityViewer = ({ type }) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Add class to body when component mounts
    document.body.classList.add('activity-open');
    
    return () => {
      // Remove class when component unmounts
      document.body.classList.remove('activity-open');
    };
  }, []);

  const htmlContent = type === 'structured' 
    ? '/structured.html' 
    : '/unstructured.html';

  return (
    <div className="activity-viewer-container">
      {loading && <div className="loader">Loading game...</div>}
      <iframe 
        src={htmlContent}
        title={`${type} Activity`}
        className="activity-iframe"
        onLoad={() => setLoading(false)}
      />
    </div>
  );
};

export default ActivityViewer;